exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#cuadro {\r\n\twidth: 200px;\r\n\theight: 300px;\r\n\tbackground: black;\r\n}\r\n\r\nli a: hover {\r\n\r\n\tfont-style: none;\r\n\ttext-decoration: none;\r\n}\r\n\r\n\r\nh3 {\r\n\tdisplay: inline-block;\r\n}\r\n\r\n.destacados {\r\n\tpadding: 10px;\r\n    margin: 10px 0px;\r\n}\r\n\r\n.destacados:first-child {\r\n\tmargin-top: 0px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Domin/OneDrive/Proyectos/GyCPlaza/src/app/lugares/lugares.component.css
// module id = ../../../../../src/app/lugares/lugares.component.css
// module chunks = main